import Component from '../core/Component';

export default class FileInput extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        var self = this;
        this.$element.find('input[type=file]').on('change', () => {
            var filename = this.$element.find('input[type=file]').val().replace(/C:\\fakepath\\/i, '');
            if (filename != "") {
                this.$element.find('.file__placeholder').text(filename);
            }
        });
    }


}


// WEBPACK FOOTER //
// ./components/FileInput.js